<template>
  <v-row class="mt-0">
    <v-col xl="3" lg="4" md="4" sm="12" cols="12">
      <v-card flat class="mb-1 h-100">
        <v-card-title class="pb-0 subtitle-1 font-weight-bold">
          Concessões
        </v-card-title>

        <v-list three-line class="mt-2">
          <v-list-item-group
            v-model="concessaoSelec"
            mandatory
            active-class="green--text"
          >
            <v-list-item v-for="(concessao, i) in demonstrativos" :key="i">
              <v-list-item-content>
                <v-list-item-title class="subtitle-1">
                  <p class="mb-0 subtitle-2 grey--text">Período de Férias</p>
                  <p class="font-weight-bold">
                    {{ formatarData(concessao.dt_in_pg) }} a
                    {{ formatarData(concessao.dt_fi_pg) }}
                  </p>
                  <p class="mb-0 subtitle-2 grey--text">Líquido a Receber:</p>
                  <p class="font-weight-bold">
                    {{ formatarMoeda(concessao.tot_liq_receber) }}
                  </p>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>
    <v-col xl="9" lg="8" md="8" sm="12" cols="12">
      <detalhes-concessao :concessao="demonstrativos[concessaoSelec]" />
    </v-col>
  </v-row>
</template>

<script>
import { dateFormat, formatMoeda } from "@/global";
import DetalhesConcessao from "./DetalhesConcessao.vue";

export default {
  components: { DetalhesConcessao },
  props: {
    demonstrativos: Array,
  },
  data: () => ({
    concessaoSelec: 0,
  }),
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    formatarData(value) {
      return dateFormat(value);
    },
  },
};
</script>
